<template>
  <tr>
    <td class="ac">{{ item.orderNo }}</td>
    <td class="ac">{{ item.sapOrderNo }}</td>
    <td class="ac">{{ item.erdDat }}</td>
    <td>
      <template v-if="item.statCd == '0'">
        {{ item.posnr1 }}
      </template>
      <template
        v-if="
          item.statCd == '1' ||
          item.statCd == 'A' ||
          item.statCd == 'B' ||
          item.statCd == 'C'
        "
      >
        {{ item.posnr2 }}
      </template>
      <template v-if="item.statCd == 'C2'">
        <template v-if="item.kwmeng == 0">
          {{ item.posnr1 }}
        </template>
        <template v-else>
          {{ item.posnr2 }}
        </template>
      </template>
    </td>
    <td class="ar">{{ Number(item.goodsPrc).toLocaleString() }}원</td>
    <td class="ac">{{ item.dlvMthdNm }}</td>
    <td class="ac">
      <template
        v-if="
          item.dlvMthdCd == 10 || item.dlvMthdCd == 15 || item.dlvMthdCd == 25
        "
      >
        {{ item.addr }}
      </template>
      <template v-if="item.dlvMthdCd == 20">
        {{ item.dlvBranchCd }}
      </template>
      <template v-if="item.dlvMthdCd == 30">
        {{ Utils.replace(item.werks, "노루페인트", "") }}
      </template>
    </td>
    <td class="ac">
      <template
        v-if="
          item.statCd == '0' ||
          item.statCd == '1' ||
          item.statCd == 'A' ||
          item.statCd == 'B'
        "
      >
        <div class="c-process-state">
          <ol>
            <li
              :class="{
                'is-current': item.statCd == '0',
              }"
              :aria-current="item.statCd == '0' ? 'step' : null"
            >
              <span class="step-circle"></span>
              <span class="text">주문대기</span>
            </li>
            <li
              :class="{
                'is-current': item.statCd == '1',
              }"
              :aria-current="item.statCd == '1' ? 'step' : null"
            >
              <span class="step-circle"></span>
              <span class="text">주문접수</span>
            </li>
            <li
              :class="{
                'is-current': item.statCd == 'A',
              }"
              :aria-current="item.statCd == 'A' ? 'step' : null"
            >
              <span class="step-circle"></span>
              <span class="text">제품준비</span>
            </li>
            <li
              :class="{
                'is-current': item.statCd == 'B',
              }"
              :aria-current="item.statCd == 'B' ? 'step' : null"
            >
              <span class="step-circle"></span>
              <span class="text">배송중</span>
            </li>
          </ol>
        </div>
      </template>
      <template v-if="item.statCd == 'C'">
        <div>
          <span class="c-util-button type-line-primary type-small type-round">
            <span class="bold">{{ item.statNm }}</span>
          </span>
        </div>
      </template>
      <template v-if="item.statCd == 'C2'">
        <div>
          <span class="c-util-button type-line-gray type-small type-round">
            <span class="bold">{{ item.statNm }}</span>
          </span>
        </div>
      </template>
    </td>
  </tr>
</template>
<script setup>
import { ref, defineProps } from "vue";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const item = ref(props.item);
</script>
